export default __webpack_public_path__ + "static/media/alipay.33c343f7.png";